var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAguaGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7596 0C48.8105 9.78512 56.3099 17.4545 63.2921 25.6529C75.4463 39.6694 74.6705 58.1818 62.2577 70.876C50.1035 83.0413 30.1914 83.0413 17.7786 70.876C5.36585 58.4463 4.59006 39.6694 16.4856 25.6529C23.2092 17.4545 30.9672 9.78512 39.7596 0Z",
    fill: "#004B2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAguaGreen);
export default __webpack_public_path__ + "static/media/agua-green.deda8655d317a38aede9f49c553fe1c0.svg";
export { ForwardRef as ReactComponent };